// "Back" on every screen (client, 2026-10-30: "kisi pe click kiya toh us
// page pe redirect karta hai, lekin wapis aane ka koi back button nahi hai —
// pura wapis se kholna padta hai"). It returns to the exact previous URL in
// the app, so a list or filter kept in the URL comes back as it was. Opened
// straight from a link (nothing to go back to), it goes up one level instead.
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ROUTES } from '@/routes/paths';

/** One level up: /pipeline/123/edit → /pipeline/123 → /pipeline → dashboard. */
function parentPath(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length <= 1) return ROUTES.dashboard;
  return `/${parts.slice(0, -1).join('/')}`;
}

export function BackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // React Router numbers this tab's in-app history; 0 is where the app was opened.
  const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
  const canGoBack = idx > 0;
  if (!canGoBack && (pathname === ROUTES.dashboard || pathname === '/')) return null;

  return (
    <button
      type="button"
      onClick={() => (canGoBack ? navigate(-1) : navigate(parentPath(pathname)))}
      className="flex items-center gap-1.5 rounded-lg border border-input px-2 py-1.5 text-body-sm font-medium text-on-surface-variant transition-colors hover:bg-muted hover:text-on-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label="Go back"
      title="Back to the previous screen (Alt + ←)"
    >
      <ArrowLeft className="h-4 w-4" />
      <span className="hidden sm:inline">Back</span>
    </button>
  );
}
